import type { MouseEvent } from 'react'

import type { PredictionContract } from '@/services/prediction/types'

import { formatPercentage } from '../utils/formatPercentage'
import { ActivePriceCellShell, LockedPriceCell } from './RedesignedPriceCellShell'

interface PriceCellProps {
  market: 'moneyline'
  contract: PredictionContract | null
  onContractClick?: (contract: PredictionContract) => void
}

/**
 * Adapted from cdc-web `Compact/_shared/PriceCell.tsx`。
 *
 * 差异（均已决策）：
 * - moneyline-only：去掉 `side`（Buy/Sell）与 spread/total 的 lineLabel 分支；
 * - cdc-market 只有百分比赔率（无 useOddsFormat），active 文本固定
 *   `formatPercentage(contract.yes)`；
 * - 没有 betslip / 事件详情路由（本区不做路由跳转），点击只冒泡给可选的
 *   `onContractClick` stub 并 stopPropagation。
 *
 * 两态不变：无报价（`!contract || !contract.chance`）→ LockedCell；否则 ActiveCell。
 */
export function PriceCell({ contract, onContractClick }: Readonly<PriceCellProps>) {
  if (!contract || !contract.chance) {
    return <LockedPriceCell />
  }

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onContractClick?.(contract)
  }

  return <ActivePriceCellShell label={formatPercentage(contract.yes)} onClick={handleClick} />
}
